import { useBaseStore } from '../base';
import { useConferenceStore } from '../conference';
import { useConfigStore } from '../config';
import { useConnectionStore } from '../connection';
import { useParticipantStore } from '../participants';
import { useTracksStore } from '../tracks';

// Reset all stores to their initial state
export function resetAllStores() {
  useBaseStore.getState().reset();
  useConferenceStore.getState().reset();
  useConfigStore.getState().reset();
  useConnectionStore.getState().reset();
  useParticipantStore.getState().reset();
  useTracksStore.getState().reset();
}
